var _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBlockRiparian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_716",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 60,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 74.371C53.2924 74.371 66.5 60.9906 66.5 44.485C66.5 27.9794 53.2924 14.599 37 14.599C20.7076 14.599 7.5 27.9794 7.5 44.485C7.5 60.9906 20.7076 74.371 37 74.371Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_716)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5808 53.03C87.0098 53.03 63.6728 58.497 63.6728 58.497L35.3668 51.474L5.55078 53.03V69.888C5.55078 69.888 33.2128 77.729 46.9018 77.729C60.5918 77.729 93.6978 69.888 93.6978 69.888C93.6978 69.888 93.1928 53.03 88.5808 53.03Z",
    fill: "#364052"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5105 52.3C18.0765 52.844 17.7305 53.443 17.6605 53.96C17.4225 55.687 22.7325 54.09 28.8505 55.179C34.9685 56.269 33.4235 58.749 30.8785 60.665C28.3335 62.581 38.3145 62.53 48.0185 63.935C48.9555 64.07 59.0215 65.228 59.7325 65.533L60.0225 60.012L58.9615 80.258L3.9375 77.374L5.2875 51.606L18.5105 52.3ZM23.5415 65.294C20.6955 64.313 19.4215 62.744 20.8065 61.626C22.1795 60.517 24.8145 59.41 27.0825 58.442C31.6385 56.5 22.4625 56.029 18.5275 55.822C15.6745 55.673 17.0275 53.422 18.0315 52.274L5.2875 51.606L3.9645 76.848L10.9545 77.215C15.4565 73.858 29.3835 77.681 37.7275 73.885C46.0715 70.087 30.7335 67.775 23.5415 65.294Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.765 25.5V29.113L49.049 32.326V28.767H46.269V33.091L38.27 35.284V31.49H36V52.755H38.27V49.024L46.27 50.994V55.194H49.047V51.679L60.762 54.566V58.5H64L63.999 25.5H60.765ZM60.765 32.69V36.49L49.049 37.91V34.974L60.765 32.69ZM49.047 40.5L60.762 40.062V43.567L49.047 43.332V40.5ZM46.269 43.275L38.27 43.115V40.906L46.27 40.606V43.276L46.269 43.275ZM46.269 35.519V38.251L38.27 39.221V37.081L46.269 35.519ZM38.27 47.106V45.021L46.27 45.789V48.422L38.27 47.106ZM49.047 48.882V46.058L60.762 47.183V50.809L49.047 48.882Z",
    fill: "#364052"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 45C66.5 61.0163 53.5163 74 37.5 74C21.4837 74 8.5 61.0163 8.5 45C8.5 28.9837 21.4837 16 37.5 16C53.5163 16 66.5 28.9837 66.5 45Z",
    stroke: "#364052",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockRiparian);
export default __webpack_public_path__ + "static/media/ic-block-riparian.3fc97849d648629fc6e65b605f97ca87.svg";
export { ForwardRef as ReactComponent };